export const websiteStatus = {
  DEMO: 'demo',
  CREATION: 'creation',
  LIVE: 'live',
  DEACTIVATED: 'deactivated',
};
